import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@pwc/appkit-react/lib/Checkbox';

export const normalizeClientId = value => {
  if (value == null || value === '') {
    return null;
  }

  return String(value);
};

export const DeploymentClientCheckboxCellRenderer = ({ data, onToggleClient }) => {
  if (!data?.isClientSelectable) {
    return null;
  }

  const clientId = normalizeClientId(data.id ?? data.clientId);

  if (!clientId) {
    return null;
  }

  return (
    <span
      onClick={event => event.stopPropagation()}
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Checkbox checked={Boolean(data.isSelected)} onChange={() => onToggleClient(clientId)} />
    </span>
  );
};

DeploymentClientCheckboxCellRenderer.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isClientSelectable: PropTypes.bool,
    isSelected: PropTypes.bool,
  }),
  onToggleClient: PropTypes.func.isRequired,
};

export const DeploymentClientHeaderCheckbox = ({
  selectableClientIds,
  selectedClientIds,
  onToggleAll,
}) => {
  const allSelected =
    selectableClientIds.length > 0 &&
    selectableClientIds.every(id => selectedClientIds.includes(normalizeClientId(id)));

  return (
    <span
      onClick={event => event.stopPropagation()}
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Checkbox
        checked={allSelected}
        disabled={!selectableClientIds.length}
        onChange={() => onToggleAll(!allSelected)}
      />
    </span>
  );
};

DeploymentClientHeaderCheckbox.propTypes = {
  selectableClientIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
    .isRequired,
  selectedClientIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
    .isRequired,
  onToggleAll: PropTypes.func.isRequired,
};
